import { createFileRoute } from '@tanstack/react-router'

import { RewindScreen } from './-components/rewind-screen.tsx'

export const Route = createFileRoute('/merchants/rewind')({
  component: RewindScreen
})
